import { render, staticRenderFns } from "./partnersUsBenefits.vue?vue&type=template&id=4db096b9&scoped=true&"
import script from "./partnersUsBenefits.vue?vue&type=script&lang=js&"
export * from "./partnersUsBenefits.vue?vue&type=script&lang=js&"
import style0 from "./partnersUsBenefits.vue?vue&type=style&index=0&id=4db096b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db096b9",
  null
  
)

export default component.exports